/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import FormLayout from "../../layout/form";
import styles from '../../../styles/SuspendedMessage.module.css';
// import { isNil } from "lodash";
import isNil from 'lodash/isNil';
import { setStage } from '../../../redux/userRolesSlice';
import { useAppDispatch} from '../../../redux/hooks';
import { useEffect } from "react";


interface Props {
    header: string,
    description?:string
    nextStepMessage?:string
    nextStepMessageHTML?: JSX.Element;
    button?:JSX.Element
  }
  export default function SuccessPage ({header,description,nextStepMessage,button=<></>,nextStepMessageHTML=<></>}: Props) {

    const dispatch = useAppDispatch();
  
    useEffect(() => {
      return () => {dispatch(setStage('OrgEngine'))};
    }, [])
  
    const getNextStep = () => {
  
      if (nextStepMessageHTML === <></>){
        if (!isNil(nextStepMessage) && nextStepMessage.trim() !== '') {
          return (<div className={styles.subFrameNextSteps}>
            <h1 className={styles.nextStepHeading}>Next Steps</h1>
            <div className={styles.steps}>
              <p className={styles.nextStepDescription} dangerouslySetInnerHTML={ {__html:nextStepMessage}}/>
            </div>
          </div>);
        } else {
          <></>
        }
      } else {
          return (<div className={styles.subFrameNextSteps}>
            <h1 className={styles.nextStepHeading}>Next Steps</h1>
            <div className={styles.steps}>
              {nextStepMessageHTML}
            </div>
          </div>);
      }
  
    }
  
    return (
      <FormLayout
        header={header}
        subHeader={description}
        button={button}>
        {getNextStep()}
        <br />
        <div className={styles.subFrameAssistance}>
          <h1 className={styles.assistanceHeading}>EngineWise® Connect Portal assistance</h1>
          <div className={styles.assistance}>
            <p className={styles.assistanceDescription}>For further assistance with EngineWise® Connect Portal, please contact the EngineWise® Connect Portal team at <a href="mailto:gppwolsregistration@prattwhitney.com" target="_blank" style = {{textDecoration:"none"}}>gppwolsregistration@prattwhitney.com</a>.</p>
          </div>
        </div>
        <br /> 
  
      </FormLayout>
    );
  };